"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCross = void 0;
var React = __importStar(require("react"));
var IconCross = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M12.707,12 L19.853,4.854 C20.049,4.658 20.049,4.342 19.853,4.146 C19.658,3.951 19.342,3.951 19.146,4.146 L12,11.293 L4.853,4.146 C4.658,3.951 4.342,3.951 4.146,4.146 C3.951,4.342 3.951,4.658 4.146,4.854 L11.293,12 L4.146,19.146 C3.951,19.342 3.951,19.658 4.146,19.854 C4.244,19.951 4.372,20 4.5,20 C4.628,20 4.756,19.951 4.853,19.854 L12,12.707 L19.146,19.854 C19.244,19.951 19.372,20 19.5,20 C19.628,20 19.756,19.951 19.853,19.854 C20.049,19.658 20.049,19.342 19.853,19.146 L12.707,12 Z" }))); };
exports.IconCross = IconCross;
exports.IconCross.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconCross;
